import React from 'react';
import { useTranslation } from 'react-i18next';

export function AlignmentConfig({ obj, handleAlignment, noPadding, index }) {
  const { t } = useTranslation('common');

  return (
    <div className={`${noPadding ? 'p-0' : 'p-2'}`}>
      <p className="mb-2 f-14"> {t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.ALIGNMENT_CONFIG.ALIGNMENT')}</p>
      <div className="alignment-container">
        <div className="align-radio-control mr-2">
          <input
            type="radio"
            id={typeof index === 'number' ? `left_${index}` : 'left'}
            onChange={handleAlignment}
            checked={obj?.otherConfiguration?.alignment === 'left'}
            name={typeof index === 'number' ? `alignment_${index}` : 'alignment'}
            value="left"
          />
          <label htmlFor={typeof index === 'number' ? `left_${index}` : 'left'} title={t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.ALIGNMENT_CONFIG.LEFT')}>
            <span className="sr-only">{t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.ALIGNMENT_CONFIG.LEFT')}</span>
            <span className="icon-align_left_new" />
          </label>
        </div>
        <div className="align-radio-control mr-2">
          <input
            type="radio"
            id={typeof index === 'number' ? `center_${index}` : 'center'}
            onChange={handleAlignment}
            checked={obj?.otherConfiguration?.alignment === 'center'}
            name={typeof index === 'number' ? `alignment_${index}` : 'alignment'}
            value="center"
          />
          <label htmlFor={typeof index === 'number' ? `center_${index}` : 'center'} title={t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.ALIGNMENT_CONFIG.CENTER')}>
            <span className="sr-only">{t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.ALIGNMENT_CONFIG.CENTER')}</span>
            <span className="icon-align_center_new" />
          </label>
        </div>
        <div className="align-radio-control mr-2">
          <input
            type="radio"
            id={typeof index === 'number' ? `right_${index}` : 'right'}
            onChange={handleAlignment}
            checked={obj?.otherConfiguration?.alignment === 'right'}
            name={typeof index === 'number' ? `alignment_${index}` : 'alignment'}
            value="right"
          />
          <label htmlFor={typeof index === 'number' ? `right_${index}` : 'right'} title={t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.ALIGNMENT_CONFIG.RIGHT')}>
            <span className="sr-only">{t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.ALIGNMENT_CONFIG.RIGHT')}</span>
            <span className="icon-align_right_new" />
          </label>
        </div>
      </div>
    </div>
  );
}

export default AlignmentConfig;
